export default function filePreviewDirective(app) {
	app.directive('filePreview', function(BaseService) {
		return {
			restrict: 'A',
			scope: {
				successIndicator: '=',
				mime: '<',
				filePath: '<',
				isBase64: '<'
			},
			link: function(scope, element) {
				function convertDataURIToBinary(base64) {
					let binary_string =  window.atob(base64);
					let len = binary_string.length;
					let bytes = new Uint8Array(len);
					for (let i = 0; i < len; i++)        {
						bytes[i] = binary_string.charCodeAt(i);
					}
					return bytes;
				}
				function loadImageData() {
					let imageParams = {
						urlParameters: {
							url: scope.filePath
						}
					};
					BaseService.createPromise('getInvoiceImage', imageParams).then(result => {
						if (/.*pdf.*/.test(scope.mime)) {
							try {
								pdfjsLib.getDocument(scope.filePath).then(pdf => {
									pdf.getPage(1).then(page => {
										let c = element[0];
										let ctx = c.getContext('2d');
										let viewport = page.getViewport(c.width / page.getViewport(1.0).width);
										c.height = viewport.height;
										page.render({canvasContext: ctx, viewport: viewport});
										scope.successIndicator = true;
									})
								});
							} catch (e) {
								scope.successIndicator = false;
							}
						} else if (/.*image.*/.test(scope.mime)) {
							try {
								let canvas = element[0],
									ctx = canvas.getContext("2d"),
									image = new Image();
								image.onload = function() {
									canvas.height = image.height * canvas.width / image.width;
									ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height);
									scope.successIndicator = true;
								};
								image.src = scope.filePath;
							} catch (e) {
								scope.successIndicator = false;
							}
						} else {
							scope.successIndicator = false;
						}
					})
					.catch(() => {
						scope.successIndicator = false;
					})
				}
				scope.$watch('filePath', () => {
					loadImageData();
				});
			}
		};
	});
}
